import React from 'react';

import { PurposeMapCardProps } from '../charts/SoulMatrix/types';

import styles from './PurposeMap.module.scss';

function PurposeMapCard({ title, description, children }: PurposeMapCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.cardInfo}>
        <div className={styles.title}>{title}</div>
        <div className={styles.cardDescription}>
          {description.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className={styles.cardCalculation}>{children}</div>
    </div>
  );
}

export default React.memo(PurposeMapCard);
